import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";
import {
  useState,
  createContext,
  useCallback,
  useContext,
  useEffect
} from "react";

export const AlertContext = createContext({
  error: null,
  addError: () => {},
  removeError: () => {}
});

export const AlertProvider = (props) => {
  const [alert, setAlert] = useState({ error: "", message: "", type: "" });
  const removeAlert = () => setAlert({ error: "", message: "", type: "" });
  const showAlert = ({ error, message, type }) =>
    setAlert({ error, message, type });

  const contextValue = {
    alert,
    showAlert: useCallback((message, type) => showAlert(message, type), []),
    removeAlert: useCallback(() => removeAlert(), [])
  };

  useEffect(() => {
    if (alert.type) setTimeout(() => removeAlert(), 3000);
  }, [alert]);

  return (
    <AlertContext.Provider value={contextValue}>
      {alert.type && (
        <Alert
          variant={alert.type}
          className="w-50 z-3 position-fixed top-50 start-50 translate-middle"
          onClose={removeAlert}
          dismissible
        >
          <Alert.Heading>{alert.error}</Alert.Heading>
          <p>{alert.message}</p>
        </Alert>
      )}
      {props.children}
    </AlertContext.Provider>
  );
};

AlertProvider.propTypes = {
  children: PropTypes.node
};

export const useAlert = () => {
  const { alert, showAlert, removeAlert } = useContext(AlertContext);
  return { alert, showAlert, removeAlert };
};
